import { doc, getDoc, runTransaction } from "firebase/firestore";
import { db } from "../../firebase/config";
import {
  buildCashOutTransactionId,
  recordCashOutLedgerEntry,
} from "./cashOutLedger";

const WALLET_REF = doc(db, "cashOutMeta", "rewardsRetirementWallet");

export async function getRewardsRetirementWallet() {
  const snap = await getDoc(WALLET_REF);
  if (!snap.exists()) {
    return { earned: 0, balance: 0, transactionCount: 0 };
  }
  const d = snap.data();
  return {
    earned: Number(d.earned) || 0,
    balance: Number(d.balance) || 0,
    transactionCount: Number(d.transactionCount) || 0,
    updatedAt: d.updatedAt || null,
  };
}

/** Credit platform Rewards & Retirement wallet (₹150 per COP enrollment + Step 4 leg). */
export async function creditRewardsRetirementWallet(amount, meta = {}) {
  const amt = Number(amount);
  if (amt <= 0) return { credited: false };

  await runTransaction(db, async (tx) => {
    const snap = await tx.get(WALLET_REF);
    const prev = snap.exists() ? snap.data() : {};
    const earned = (Number(prev.earned) || 0) + amt;
    const balance = (Number(prev.balance) || 0) + amt;
    tx.set(
      WALLET_REF,
      {
        earned,
        balance,
        transactionCount: (Number(prev.transactionCount) || 0) + 1,
        updatedAt: new Date().toISOString(),
      },
      { merge: true }
    );
  });

  await recordCashOutLedgerEntry({
    transactionId: buildCashOutTransactionId(),
    programId: meta.programId || null,
    userId: meta.userId || null,
    level: meta.level ?? null,
    amount: amt,
    transactionType: "REWARDS_RETIREMENT",
    fromWallet: meta.fromWallet || "COP_MATRIX",
    toWallet: "REWARDS_RETIREMENT",
    fillerUserId: meta.fillerUserId || null,
    reference: meta.reference || null,
    metadata: meta.metadata || null,
  });

  return { credited: true, amount: amt };
}
